import isNull from 'shared/libs/isNull/isNull'

import NumberFormat from 'shared/ui/NumberFormat'

const Number = (props: any) => {
  const {
    children,
    maximumFractionDigits = 2,
    minimumFractionDigits = 2,
  } = props

  const value = children?.[1]

  if (isNaN(+value) || isNull(value)) return '-'

  return (
    <NumberFormat
      value={value}
      minimumFractionDigits={minimumFractionDigits}
      maximumFractionDigits={maximumFractionDigits}
    />
  )
}

export default Number
